var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTopic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 17.6 23.7",
    style: {
      enableBackground: "new 0 0 17.6 23.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.8,23.1L8.8,23.1c-0.5,0-0.9-0.2-1.2-0.6l-5.9-8.2c0,0,0,0-0.1-0.1l-0.2-0.3c0-0.1-0.1-0.1-0.1-0.2 c-0.1-0.1-0.1-0.2-0.2-0.3C0.4,12,0,10.5,0,9c0-4.8,3.9-8.8,8.8-8.8s8.8,3.9,8.8,8.8c0,1.7-0.5,3.3-1.3,4.7c0,0.1-0.1,0.1-0.1,0.2 l-0.2,0.3l-6,8.4C9.7,22.9,9.2,23.1,8.8,23.1z M3.9,12.4L4,12.5c0,0,0.1,0.1,0.1,0.1l4.7,6.6l4.9-6.9c0,0,0,0,0-0.1 c0.6-1,1-2.1,1-3.2c0-3.3-2.6-5.9-5.9-5.9C5.5,3.1,2.9,5.8,2.9,9c0,1,0.3,2,0.8,2.9c0,0.1,0.1,0.1,0.1,0.2l0.1,0.1 C3.9,12.3,3.9,12.3,3.9,12.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopic);
export default __webpack_public_path__ + "static/media/topic.eb90791a455495e0db190bb133fbc372.svg";
export { ForwardRef as ReactComponent };